import React, {useState} from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {
    Form, Input, Button, Spin, InputNumber,
    // DatePicker, Upload, message,
} from 'antd';
import {Row, Col} from 'antd';
import {Select} from 'antd';
// import TextArea from "antd/lib/input/TextArea";
// import {openNotificationWithIcon} from "./Function";
// import Cookies from 'universal-cookie';
// const cookies = new Cookies
// const {Option} = Select;
// const layout = {
//     labelCol: {span: 22, offset: 1},
//     wrapperCol: {span: 22, offset: 1},
// };

const validateMessages = {
        required: 'Vui lòng nhập ${label}',
    types: {
        email: '${label} không đúng định dạng email!',
        number: '${label} không phải số!',
    },
    number: {
        range: '${label} must be between ${min} and ${max}',
    },
};
const FormLayout = (data) => {
    const [listTeam, setListTeam] = useState([]);
    const [loadingSubmitForm, setLoadingSubmitForm] = useState(false);
    const [form] = Form.useForm();
    // async function waitForUpload(ticketId,file,fileOther) {
    //     let result = await Upload_Ticket_File(ticketId,file.file.originFileObj)
    // }
    const onFinish = (values) => {

    };
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
  const onReset = () => {
    form.resetFields();
  };
    // const handleChange_bophanxuly = (value) => {
    //     authAxios(cookies.get('token'))
    //         .get(listLoaiyeucau(value))
    //         .then(res => {
    //             setLoaiyeucau(res.data);
    //             form.setFieldsValue({
    //                 assigned_loaiyeucau: '',
    //             });
    //         })
    //         .catch(err => {
    //             if (err.response.status === 401) {
    //                 this.props.history.push('/login');
    //             }
    //         });
    // };

    return (
            <Spin spinning={loadingSubmitForm} tip="Đang tạo yêu cầu vui lòng đợi....">
                <Row>
                    <Col span={14} offset={5}>
                <Form form={form} layout="vertical" name="userForm" validateMessages={validateMessages} labelAlign={"left"}
                      onFinish={onFinish} onFinishFailed={onFinishFailed}>
                    <Row>
                        <Col sm={10} offset={1}>
                            <Form.Item
                                name="tendangnhap"
                                label="Tên đăng nhập"
                                rules={[
                                    {required: true},
                                ]}
                            >
                                <Input/>
                            </Form.Item>

                            <Form.Item
                                name="ho"
                                label="Họ"
                                rules={[
                                    {
                                        required: true,
                                    },
                                ]}
                            >
                                <Input/>
                            </Form.Item>
                            <Form.Item
                                name="ten"
                                label="Tên"
                                rules={[
                                    {
                                        required: true,
                                    },
                                ]}
                            >
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col sm={10} offset={1}>
                            <Form.Item
                                name="msnv"
                                label="Mã số nhân viên"
                                rules={[
                                    {
                                        required: true,
                                    },
                                    {type:'number'}
                                ]}
                            >
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                name="team"
                                label="Team"
                                rules={[
                                    {
                                        required: true,
                                    },
                                ]}
                            >
                                <Select>
                                    {listTeam.map((item,index) => (<Select.Option key={index} value={item.id}>{item.name}</Select.Option>))}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                name="email"
                                label="Email"
                                rules={[
                                  {
                                    type: 'email',
                                    message: 'Vui lòng nhập đúng định dạng E-mail!',
                                  },
                                  {
                                    required: true,
                                    message: 'Vui lòng nhập E-mail!',
                                  },
                                ]}
                            >
                                <Input/>
                            </Form.Item>

                        </Col>
                    </Row>
                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Tạo yêu cầu
                    </Button>
                    <Button htmlType="button" onClick={onReset} style={{marginLeft:20}} type="danger">
                      Làm lại
                    </Button>
                </Form.Item>
        </Form>
                        </Col>
                </Row>

        </Spin>
    )
}

class UserCreate extends React.Component {
    state = {
        loading: false,
        error: null,
    };

    componentDidMount() {

    }


    render() {
        return (
            <FormLayout {...this.state}/>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        // refreshCart: () => dispatch(fetchCart())
    };
};

export default withRouter(
    connect(
        null,
        mapDispatchToProps
    )(UserCreate)
);
